module.exports = __webpack_public_path__ + "img/logo@2x.e2a4951a.png";